import { API_ROUTES } from '@/api/apiRoutes';
import { appendQsFromArray } from '@/utils/urls';
import { WorkspaceModelStatus } from '@/types/api/modelDefinition';
import { safeAxios } from '@/services/safeAxios';
import type { ModelApprovalStatusesResponse } from '@/types/api/modelApproval';

export const requestModelApproval = async (
  workspaceId: string,
  body: { modelId: string; providerId: string; modelName?: string },
): Promise<boolean> => {
  const response = await safeAxios.post(API_ROUTES.workspaces.modelApprovalRequests({ workspaceId }), body);
  return response.status === 201;
};

export const getModelApprovalStatuses = async (
  workspaceId: string,
  modelIds: string[],
): Promise<ModelApprovalStatusesResponse> => {
  const params = appendQsFromArray('modelIds', modelIds);
  const response = await safeAxios.get<ModelApprovalStatusesResponse>(
    API_ROUTES.workspaces.modelApprovalRequests({ workspaceId }),
    { params },
  );
  return response.data;
};

export const reviewModelApproval = async (
  workspaceId: string,
  body: { modelId: string; status: WorkspaceModelStatus.Approved | WorkspaceModelStatus.Rejected },
): Promise<void> => {
  await safeAxios.patch(API_ROUTES.workspaces.modelApprovalRequests({ workspaceId }), body);
};
